import { render, staticRenderFns } from "./ScholarshipApplication.vue?vue&type=template&id=866a6498"
import script from "./ScholarshipApplication.vue?vue&type=script&lang=js"
export * from "./ScholarshipApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports